import React, { useEffect, useState } from 'react'
import { bindEvent } from '../modules/bindEvent'

import { useSelector, useDispatch } from 'react-redux'
import store, {
	RootState,
	AppDispatch,
	useAppDispatch,
	methods,
	notesSlice,
	configSlice,
	userSlice,
} from '../store'
import './VerifyAccount.scss'
import { api } from '../modules/electron/api'
import { useTranslation } from 'react-i18next'
import { prompt, alert } from '@saki-ui/core'
import { Debounce, NEventListener } from '@nyanyajs/utils'
import { sakisso } from '../config'
import { SakiSso } from './saki-ui-react/components'

export let verifyAccountEventListener = new NEventListener()

const loginDebounce = new Debounce()

export const VerifyAccountComponent = () => {
	const { t, i18n } = useTranslation()
	const appStatus = useSelector((state: RootState) => state.config.status)
	const config = useSelector((state: RootState) => state.config)
	const appearance = useSelector((state: RootState) => state.appearance)
	const user = useSelector((state: RootState) => state.user)

	const [noteContextMenuEl, setNoteContextMenuEl] = useState<any>()
	const [openDropDownMenu, setOpenDropDownMenu] = useState(false)
	const [openAddDropDownMenu, setOpenAddDropDownMenu] = useState(false)
	const [openSettingDropDownMenu, setOpenSettingDropDownMenu] = useState(false)
	const [openUserDropDownMenu, setOpenUserDropDownMenu] = useState(false)

	const dispatch = useDispatch<AppDispatch>()
	// useEffect(() => {
	// 	// console.log('checkUserres', user.userInfo)
	// }, [user.userInfo])

	// setTimeout(() => {
	// 	store.dispatch(
	// 		configSlice.actions.setStatus({
	// 			type: 'loginModalStatus',
	// 			v: true,
	// 		})
	// 	)
	// }, 1000)

	return (
		<saki-modal
			max-width={config.deviceType === 'Mobile' ? 'auto' : '500px'}
			min-width={config.deviceType === 'Mobile' ? 'auto' : '400px'}
			max-height={config.deviceType === 'Mobile' ? 'auto' : '440px'}
			min-height={config.deviceType === 'Mobile' ? 'auto' : '400px'}
			width='100%'
			height='100%'
			border-radius={config.deviceType === 'Mobile' ? '0px' : ''}
			border={config.deviceType === 'Mobile' ? 'none' : ''}
			mask
			background-color='#fff'
			onClose={() => {
				dispatch(userSlice.actions.setVerifyAccountEventName(''))
			}}
			z-index='1011'
			visible={!!user.verifyAccountEventName}
		>
			<div className='verify-account-component'>
				<saki-modal-header
					ref={bindEvent({
						close: () => {
							dispatch(userSlice.actions.setVerifyAccountEventName(''))
						},
					})}
					closeIcon
					title={t('verifyAccount', {
						ns: 'common',
					})}
				/>
				{!!user.verifyAccountEventName ? (
					<SakiSso
						onVerifyAccount={(e) => {
							loginDebounce.increase(() => {
								console.log('verifyAccount', e.detail.token)

								verifyAccountEventListener.dispatch(
									user.verifyAccountEventName,
									e.detail.token
								)

								verifyAccountEventListener.removeEvent(
									user.verifyAccountEventName
								)
								dispatch(userSlice.actions.setVerifyAccountEventName(''))
							}, 10)
						}}
						onLogin={(e) => {
							loginDebounce.increase(() => {
								store.dispatch(
									userSlice.actions.login({
										token: e.detail.token,
										deviceId: e.detail.deviceId,
										userInfo: e.detail.userInfo,
									})
								)
								store.dispatch(configSlice.actions.setSync(true))
								dispatch(methods.notes.Init()).unwrap()
								store.dispatch(
									configSlice.actions.setStatus({
										type: 'loginModalStatus',
										v: false,
									})
								)
							}, 100)
						}}
						style={{
							flex: 1,
						}}
						class='disabled-dark'
						language={config.language}
						appearance={appearance.mode}
						app-id={sakisso.appId}
						url={sakisso.clientUrl + '/verifyAccount?uid=' + user.userInfo.uid}
					/>
				) : (
					''
				)}
			</div>
		</saki-modal>
	)
}

export default VerifyAccountComponent
